// 出荷確認ボード
import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';

import {addBoardFunction} from './js/BoardFunction';
import Cookies from 'js-cookie'
import './css/board.css';
import CancelBadge from "./js/CancelBadge";


export default class Board extends Component{
  state={
    //authObj:{},
    tonya_obj_array:this.props.data.tonya_datas_2,
    re_tonya_array:[],
    jan_list:[],
    click_tonya_id:0
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    //console.dir(this.props.data.cm_datas); 
    // CmListBody で使用するデータをもらおうと思うと render に書かないとだめ、非同期で GET している、 render 負荷考慮でここで再取得...
    // と思ったが、 stream のことを考えると...
    //console.dir(this.props.data.tonya_datas); 
    //console.dir(this.props.data); 
    //console.log(this.state.tonya_obj_array);

    //let re_tonya_obj_array = addBoardFunction.convertTonyaArray(this.state.tonya_obj_array);
    //console.dir(re_tonya_obj_array);
    //this.setState({re_tonya_array:re_tonya_obj_array});
		//let staff_token = Cookies.get('_replace_token');
		//let staff_name = Cookies.get('_replace_staff');
		//this.setState({authObj:{"token":staff_token, "name":staff_name}})



		let tonya_list_2 = addBoardFunction.board2Soart(this.props.data.tonya_datas);
    this.props.getTonyaDatas2(tonya_list_2);


  }
  
  getJanList = async (e) => {
    console.dir(e.target);
    let tonya_id = e.target.dataset.tonya_id;
    if(this.state.click_tonya_id===0){
      this.setState({click_tonya_id:Number(tonya_id)});
    }else if(this.state.click_tonya_id!==tonya_id){
      this.setState({click_tonya_id:Number(tonya_id)});
    }else{
      this.setState({click_tonya_id:0});
    }
    

    //let this_tonya = e.target.dataset.tonya;
    //let data_array = addBoardFunction.getJanList(this_tonya, this.props.data.auth_obj);
    //this.setState({jan_list:data_array});
    

    // sort
    this.props.changeTonyaLabel_2(e.target.dataset.tonya); //表の変更イベントは CmList.js 内

    document.getElementById('search-form').scrollIntoView({behavior:"smooth"});

    //検索フォームリセット
    document.getElementById('hattyuu_no').value = '';
    document.getElementById('order_key').value = '';
    document.getElementById('jan').value = '';
    document.getElementById('cm-order-no').value = '';
    
    e.preventDefault();

  }



  closeJanInfo = async (e) => {
		this.setState({click_tonya_id:0});
	}

  
  
  render(){
    var checkboxClick = async (e) => {
			console.dir(e.target);

      let tonya_id = Number(e.target.dataset.dbId);
      let tonya_name_f = String(e.target.dataset.dbName);
      let obj_name = '';

      if(e.target.checked){
        let _elm = e.target.parentNode.parentNode.childNodes[1];
        _elm.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only"></span></div>';

        let res_2 = addBoardFunction.updateCmOrderSyukka(e.target, this.props.data.auth_obj, this.props.data);
        console.log(res_2);
        console.log(res_2.length);
        this.props.getHikiatePostIds(res_2[2]);

        if(res_2.length!==3){
          e.target.checked = false;
          return '';
        }

        let res = addBoardFunction.updateSyukaKakuninDate(e.target, this.props.data.auth_obj);
        console.log(res);

        if(res_2.length!==3){
          e.target.checked = false;
        }else{
          res_2 = res_2[0]; //予約の時変になる？
          console.log('出荷確認更新 '+String(res_2));
          for (let i = 0; i < this.props.data.tonya_datas_2.length; i++) {
            let obj_id = Number(this.props.data.tonya_datas_2[i].id);
            if(obj_id===tonya_id){
              this.props.data.tonya_datas_2[i].syukka_check_zan = this.props.data.tonya_datas_2[i].syukka_check_zan - res_2;
              //this.props.getTonyaDatas(this.props.data.tonya_datas);
            }
          }
          this.props.getTonyaDatas2(this.props.data.tonya_datas_2);
          this.props.resetFormData();

          //let check_box_elm = document.getElementsByName("index_checkbox_all")[0];
          //check_box_elm.click();
        }

      }

		}


    //console.dir(this.props.data); 

    return (
      <div className="board-area bg-light mb-5 p-3 container"  >
				<table>
					<thead>
						<tr className="table-row sticky-top my-bh-2 sticky-top-board-2">
							<td className="table-col">No.</td>
							<td className="table-col nowrap td-relative">問屋名</td>
              <td className="table-col nowrap">出荷確認完了？</td>
							<td className="table-col nowrap">確認残数</td>
							<td className="table-col">前回チェック</td>
							<td className="table-col nowrap">確認方法</td>
              
						</tr>
					</thead>

					<tbody>
          	{this.props.data.tonya_datas_2.map((row, index)=>{
              let ship_check_prev_date = null;
              try{
                ship_check_prev_date = addBoardFunction.converDate(row, 'syukka');
              }catch(error){
                console.dir(error);
                console.dir(row);
							}
              
              let index_tr_class = 'table-row';
              if(this.state.click_tonya_id===row.id){
                index_tr_class = 'table-row board-1-index-tr';
              }

              let harituke_label = false;
              let harituke_label_array = ['マルク', '阿部玩具', 'エトワール海渡'];
              if(harituke_label_array.includes(row.tonya_name)){
                harituke_label = true;
              }

          	  return(
								<tr key={'b2_'+row.id} className={index_tr_class}>

                  <td className="table-col nowrap">


                    <div 
                      className="rounded-circle index-icon text-white syukka-index" 
                    >
                      <span
                        data-tonya={row.tonya_name_f}
                        data-tonya_id={row.id}
                        onClick={this.getJanList} 
                      >
                        {index+1}
                      </span>

                      {/*
                      <table id={"jan-list-"+row.id} className={this.state.click_tonya_id===row.id ? 'board-2-pop-table jan-list-show ' : ''}>
                        <tr className="jan-list-content">
                          <td className="">{row.tonya_name_f}（{row.syukka_check_zan}）</td>
                          <td colSpan="3"> <div className="jan-info-close-button" onClick={this.closeJanInfo}><i className="bi bi-x-circle"></i></div> </td>
                        </tr>
                        <tr className="jan-list-content">
                          <td>JAN</td>
                          <td>数</td>
                          <td >KEY</td>
                          <td >発注No.</td>
                        </tr>
                        {this.state.jan_list.map((jan_obj, index2)=>{
                          if(jan_obj.tonya_name_f===row.tonya_name_f){
                            return(
                              <tr key={"jan-list"+String(index2)} className="jan-list-content">
                                <td>{jan_obj.JAN}</td>
                                <td>{jan_obj.howmany}</td>
                                <td className="px-2-important text-left-important">{jan_obj.key}</td>
                                <td className=" text-left-important">{jan_obj.hattyuu_no}</td>
                              </tr>
                            )
                          }
									      })}
                      </table>
                      */}

                    </div>
                  </td>

									<td className="table-col nowrap">
                    <a href={row.url} target="_blank" className="small text-decoration-none">{row.tonya_name}</a>
                  </td>
                  <td className="table-col nowrap  position-relative">
                    {this.props.data.isit_now_data_importing ? 
                      <>
                        <Form.Check
										    	id={row.id}
                          data-db-id={row.id}
                          data-db-name={row.tonya_name_f}
										    	onClick={event=>checkboxClick(event)}
                          disabled
										    />
                      </> 
                      : 
                      <>
                        <Form.Check
										    	id={row.id}
                          data-db-id={row.id}
                          data-db-name={row.tonya_name_f}
										    	onClick={event=>checkboxClick(event)}
										    />
                      </> 
                    }

                    <div id={"checkbox_2_"+row.id} className="checkbox_loading_icon"></div>
                  </td>
									<td className="table-col nowrap">{row.syukka_check_zan}</td> {/* 確認残数 */}
									<td className="table-col nowrap">{ship_check_prev_date}（{row.ship_check_owari_who}）</td> {/* 前回チェック */}
                  <td className="table-col nowrap position-relative">
                    {row.shipment_confirmation_method}
                    {harituke_label ? <><i className="bi bi-table mx-1"></i></> : <></> }
                    <CancelBadge
                      data={this.props.data} 
                      tonya_name_f={row.tonya_name_f}
                    />
                  </td> {/* 確認方法 */}
                 
								</tr>

          	  )
          	})}
						
					</tbody>


				</table>
        
      </div>
    );
  }
}